import moment from "moment";

export function getCurrentDateTimeForFilename(date = new Date(), format = "yyyy_mm_dd__hh_ii_ss") {
    const map = {
        mm: `${date.getMonth() + 1}`.padStart(2, "0"),
        dd: `${date.getDate()}`.padStart(2, "0"),
        yyyy: date.getFullYear(),
        hh: `${date.getHours()}`.padStart(2, "0"),
        ii: `${date.getMinutes()}`.padStart(2, "0"),
        ss: `${date.getSeconds()}`.padStart(2, "0"),
    }

    return format.replace(/mm|dd|yyyy|hh|ii|ss/gi, matched => map[matched])
}

export function getDateOffsetByDays(offset) {
    const date = new Date();
    date.setDate(date.getDate() + offset);
    return date;
}

export function dateToDMY(date) {
    return moment(date).format('DD/MM/YYYY');
}

export function dateToYMD(date) {
    return moment(date).format('YYYY-MM-DD');
}

export function todayInDMY() {
    return moment().format("DD/MM/YYYY");
}

export const formatSparkTime = (time) => {
    if(!time) {
        return "";
    }

    const {hour, minute} = time;
    return `${hour < 10 ? '0' + hour : hour}:${minute < 10 ? '0' + minute : minute}`
}

export function formatDate(isoString) {
    if (!isoString) return "—";
    return new Date(isoString).toLocaleString();
}